export default {
    WARNING_DUPLICATE: 'Duplicate item key found in store: ',
    INVALID_STORE: 'You tried to parse a non-existent store.',
    INVALID_STORE_REFRESH: 'hat versucht, ein ungültiges Geschäft zu aktualisieren: ',
    INVALID_ITEM_SELECTION: 'Ungültige Gegenstandsauswahl.',
    PURCHASE_INVALID_STORE:
        'hat versucht, einen Gegenstand zu kaufen, den es im Geschäft nicht gibt: ',
    SELL_INVALID_ITEM: 'hat versucht, einen ungültigen Gegenstand zu verkaufen.',
    ITEM_OUT_OF_STOCK: 'Dieser Gegenstand ist derzeit ausverkauft.',
    NOT_ENOUGH_CURRENCY: 'Du hast nicht genug Währung, um diesen Gegenstand zu kaufen.',
    NOT_ENOUGH_SPACE: 'Du hast nicht genug Platz in deinem Inventar.',
    CANNOT_SELL_ITEM: 'Du kannst diesen Gegenstand nicht verkaufen.',
    ACTION_STORE_NOT_OPEN:
        'hat versucht, eine Aktion in einem Geschäft durchzuführen, das nicht geöffnet ist.',
    CHEATER: 'Du wurdest als Betrüger markiert. Du kannst nichts kaufen.',
    RESTRICTED_STORE: 'Dieses Geschäft nimmt keine Gegenstände an.',
    RESTRICTED_ITEM: 'Dieser Gegenstand kann hier nicht verkauft werden.',
    INVALID_ITEM_COUNT: 'Du hast eine ungültige Anzahl von Gegenständen eingegeben.',
    HOLLOW_ADMIN: 'Du kannst als Administrator nicht mit der Wirtschaft interagieren.'
} as const;
